import { withBrowserTextareaHeight } from '@/src/general/utils/withBrowserTextareaHeight'

import { UpliftForm as UpliftFormNative } from './UpliftForm.shared'

export const UpliftForm = withBrowserTextareaHeight(UpliftFormNative)
